import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadSmevCheckSZLTListFailed, loadSmevCheckSZLTListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, SUBJECT_TYPE } from '../../../configs';

export default function* loadSmevCheckSZLTList(action) {
  try {
    const pool = {
      subject_type: SUBJECT_TYPE.ORDER_SERVICE,
      subject_id: action.payload,
    };
    const url = `${BACKEND_URL}/resources/checks/`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadSmevCheckSZLTListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadSmevCheckSZLTListFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadSmevCheckSZLTListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
